import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonDataService } from '../../common-data.service';

@Component({
  selector: 'app-roster-hierar-grid',
  templateUrl: './roster-hierar-grid.component.html',
  styleUrls: ['./roster-hierar-grid.component.scss']
})
export class RosterHierarGridComponent {

  @Input() hirarchicalgridData: any[][] = [];
  @Input() teamMemberCurrentPg: number = 1;
  @Input() teamsPerPage: number = 20;
  @Input() isDemoRoster: boolean = false;

  @Output() selectedGroupProfileTeams = new EventEmitter<any>();
  @Output() participantView = new EventEmitter<{ from: string; team: any }>();
  @Output() openCloseTeamPopup = new EventEmitter<{ open: boolean; teamId: string; teamName: string }>();
  @Output() deleteTeam = new EventEmitter<{ team: any; index: number }>();

  constructor(public CommonDataService: CommonDataService) {}

  secretEmail(usrEmail: string, length = 8): string {
    return usrEmail?.substring(0, length) + '...';
  }
}
